import ReactDOM from 'react-dom';
import React from 'react';
import Map, {MapProps} from '../components/map2';
import theme from '../theme';
import {MuiThemeProvider} from '@material-ui/core/styles';

export function render(props: MapProps, element: Element) {
    ReactDOM.render(
        <MuiThemeProvider theme={theme}>
            <Map {...props} />
        </MuiThemeProvider>,
        element
    );
}

export {MapProps};
export default Map;
